import { render, staticRenderFns } from "./add-attachment-modal.vue?vue&type=template&id=38e65b54&scoped=true"
import script from "./add-attachment-modal.vue?vue&type=script&lang=js"
export * from "./add-attachment-modal.vue?vue&type=script&lang=js"
import style0 from "./add-attachment-modal.vue?vue&type=style&index=0&id=38e65b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e65b54",
  null
  
)

export default component.exports